/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Divider} from '@chakra-ui/react'
import RecentSearches from './recent-searches'
import Suggestions from './suggestions'
import ProductSuggestions from './product-suggestions'

const SearchSuggestions = ({recentSearches, searchSuggestions, closeAndNavigate, ...props}) => {
    const useSuggestions =
        searchSuggestions &&
        (searchSuggestions?.phraseSuggestions?.length ||
            searchSuggestions?.productSuggestions?.length)

    return (
        <Stack spacing={0}>
            {useSuggestions ? (
                <Stack spacing={6}>
                    <Suggestions
                        closeAndNavigate={closeAndNavigate}
                        suggestions={searchSuggestions?.phraseSuggestions}
                        {...props}
                    />

                    {searchSuggestions?.phraseSuggestions?.length && (
                        <Divider colorScheme="stokkeGray" />
                    )}

                    <ProductSuggestions
                        closeAndNavigate={closeAndNavigate}
                        suggestions={searchSuggestions?.productSuggestions}
                        {...props}
                    />
                </Stack>
            ) : (
                <RecentSearches
                    recentSearches={recentSearches}
                    closeAndNavigate={closeAndNavigate}
                />
            )}
        </Stack>
    )
}

SearchSuggestions.propTypes = {
    recentSearches: PropTypes.array,
    searchSuggestions: PropTypes.object,
    closeAndNavigate: PropTypes.func
}

export default SearchSuggestions
